/* eslint-disable import/prefer-default-export */
import React from 'react';
import get from 'lodash/get';
import Skeleton from 'Common/Components/Skeleton';
import { Wrapper } from './styled';

export const CVSS = ({ vuln, showSkeleton }) => {
  const cvss4 = get(vuln, 'cvss4', null);
  const cvss3 = get(vuln, 'cvss3', null);
  const cvss2 = get(vuln, 'cvss2', null);
  const score = cvss4?.base_score || cvss3?.base_score || cvss2?.base_score;
  const severity = cvss4?.base_severity || cvss3?.base_severity || cvss2?.base_severity;

  if (showSkeleton) return <Skeleton />;
  if (!score) return null;
  return (
    <Wrapper color={ severity } >
        {score}
    </Wrapper>

  );
};
